import CurrencyInput from '@gp/components/CurrencyInput';
import { FINANCIALS_AMOUNT_DECIMALS } from '@gp/pages/Pipeline/ProjectDetails/Milestone/constants';
import { formatTeaFormItemMessage, formatTeaFormItemStatus } from '@gp/utils/common';
import classnames from 'classnames';
import React from 'react';
import { Col, Form, FormItem, Row } from 'tea-component';
import MilestoneFinancialsForecastTable from './ForecastTable';
import MilestoneFinancialsTable from './Table';

import type { IMilestone } from '@gp/pages/Pipeline/ProjectDetails/Milestone/types';
import type { IBaseProps } from '@home/types/common';
import type { FieldRenderProps } from 'react-final-form-hooks/dist';

import './index.scss';

interface IFinancialsFormControlProps extends IBaseProps {
  submitted: boolean;
  currentMilestoneDate?: string;
  milestones?: IMilestone[];
  devCostField: FieldRenderProps;
  keyMilestonesFinancialsField: FieldRenderProps;
  keyMilestonesFinancialsForecastField: FieldRenderProps;
}

const FinancialsFormControl: React.FC<IFinancialsFormControlProps> = (props) => {
  const {
    style,
    className,
    submitted = false,
    currentMilestoneDate,
    milestones,
    devCostField,
    keyMilestonesFinancialsField,
    keyMilestonesFinancialsForecastField,
  } = props;

  return (
    <Form
      style={style}
      className={classnames('dbg-edit-form-box dbg-financials-form-control', className)}
    >
      <Row>
        <Col span={24}>
          <FormItem
            label={
              <>
                Approved
                <br />
                Development Budget
              </>
            }
            showStatusIcon={false}
            status={formatTeaFormItemStatus(submitted, devCostField?.meta)}
            message={formatTeaFormItemMessage(submitted, devCostField?.meta)}
          >
            <CurrencyInput
              {...devCostField?.input}
              className="gr-edit-input-adornment"
              inputClassName="dbg-gr-edit-number-input-box"
              currencyUnit="M$"
              supportedDecimals
              decimalsLength={FINANCIALS_AMOUNT_DECIMALS}
              value={devCostField?.input?.value}
              onChange={(value) => {
                devCostField?.input?.onChange(value);
              }}
            />
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <FormItem
            label={
              <>
                Development Cost &
                <br />
                Headcount by
                <br />
                Milestone
              </>
            }
            showStatusIcon={false}
            status={formatTeaFormItemStatus(submitted, keyMilestonesFinancialsField?.meta)}
            message={formatTeaFormItemMessage(submitted, keyMilestonesFinancialsField?.meta)}
          >
            <MilestoneFinancialsTable
              isEdit
              currentMilestoneDate={currentMilestoneDate}
              milestones={milestones}
              value={keyMilestonesFinancialsField?.input?.value}
              onChange={(value) => {
                keyMilestonesFinancialsField?.input?.onChange(value);
              }}
            />
          </FormItem>
        </Col>
      </Row>
      <Row className={'dbg-financials-form-control-forecast'}>
        <Col span={24}>
          <FormItem
            label="Forecast Financials"
            showStatusIcon={false}
            status={formatTeaFormItemStatus(submitted, keyMilestonesFinancialsForecastField?.meta)}
            message={formatTeaFormItemMessage(
              submitted,
              keyMilestonesFinancialsForecastField?.meta,
            )}
          >
            <MilestoneFinancialsForecastTable
              isEdit
              value={keyMilestonesFinancialsForecastField?.input?.value}
              onChange={(value) => {
                keyMilestonesFinancialsForecastField?.input?.onChange(value);
              }}
            />
          </FormItem>
        </Col>
      </Row>
    </Form>
  );
};

export default FinancialsFormControl;
